import { render } from "./VentasView.vue?vue&type=template&id=cdaade9c"
import script from "./VentasView.vue?vue&type=script&lang=js"
export * from "./VentasView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__